/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Manufacturers {
    angular.module("meevo.plugins.manufacturers", []);
}